var mobileNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	}

	mobileNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	}

	class MobileNav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

			console.log(this);

		}
		init() {
			this.$trigger = $(selectors.trigger);
			this.$links = $('a', this.$container).not(this.$trigger).not('[href="#"]');

			$('li', this.$container).filter((i, el) => {
				return ($(el).children('.sub-menu').children().length > 0 && $(el).closest('.sub-menu').length == 0);
			}).append('<div class="c-nav__item-arrow">');


			this.$dropdownTrigger = $('.c-nav__item-arrow', this.$container);
		}

		bind() {

			const self = this;

			this.$trigger.click((e) => { this.toggle(); });
			this.$links.click((e) => { this.hide(); });
			this.$dropdownTrigger.click(function () { self.toggleDropdown($(this)); });
		}

		toggle() {
			if (this.$container.hasClass('is-active')) {
				this.hide();
			}
			else {
				this.show();
			}
		}

		show() {
			this.$container.addClass('is-active');
		}

		hide() {
			this.$container.removeClass('is-active');
		}

		toggleDropdown($link) {
			if ($(window).width() < 900) {
				const $submenu = $link.siblings('.sub-menu');

				if ($submenu.is(":visible")) {
					$submenu.parent().removeClass('has-open');
				}
				else {
					$submenu.parent().addClass('has-open');
				}
				$submenu.stop().slideToggle(200);
			}
		}

	}

})(jQuery);


export default mobileNavInit;